<div class="container text-center">
    <div class="heading-2">SITE ATTRIBUTES & ACCESS</div>
    <p class="heading-5 coral-text mt-2">Information is subject to availability. This addendum will generally include:</p>
    <p class="paragraph">Area demographics, distances to emergency services, dolomite
        risk, building lines; and if in proximity: existing and proposed
        roads, bus routes & railway lines.</p>
</div>